// extracted by mini-css-extract-plugin
export default {"progressLoader":"ProgressBar_progressLoader__Yo3rj","progress":"ProgressBar_progress__SJy4l"};